/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareChevronRight = createReactComponent(
  "square-chevron-right",
  "IconSquareChevronRight",
  [
    ["path", { d: "M11 9l3 3l-3 3", key: "svg-0" }],
    [
      "path",
      {
        d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareChevronRight as default };
//# sourceMappingURL=IconSquareChevronRight.js.map
